import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { SunkenPanel } from "./sunken-panel";

export type StatSize = "hero" | "hero-mobile" | "lg" | "md";

const VALUE_CLASS: Record<StatSize, string> = {
	hero: "t-num-hero",
	"hero-mobile": "t-num-hero-m",
	lg: "t-num-lg",
	md: "t-num-md",
};

export interface StatProps {
	/** Уже отформатированное число — форматирование локали живёт в приложении. */
	value: ReactNode;
	label?: ReactNode;
	/** Знак вопроса рядом с подписью или мелкая ссылка. */
	labelAfter?: ReactNode;
	size?: StatSize;
	/** Показатель без серой плашки — например, внутри уже серой карточки. */
	bare?: boolean;
	className?: string;
}

/**
 * Показатель: крупное моноширинное число и подпись под ним. Число — Geist Mono
 * с трекингом −0.03em: на 52px дефолтный трекинг делает разрядку заметной, и
 * баланс перестаёт читаться одним взглядом.
 */
export function Stat({
	value,
	label,
	labelAfter,
	size = "hero",
	bare = false,
	className,
}: StatProps) {
	const body = (
		<>
			<span className={VALUE_CLASS[size]}>{value}</span>
			{label != null || labelAfter != null ? (
				<span className="flex items-center gap-1.5 t-body text-fg-muted">
					{label}
					{labelAfter}
				</span>
			) : null}
		</>
	);

	if (bare) {
		return <div className={cn("flex flex-col gap-1", className)}>{body}</div>;
	}

	return (
		<SunkenPanel padding="stat" direction="column" className={cn("gap-1", className)}>
			{body}
		</SunkenPanel>
	);
}
